import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import Modal from '../../Modal/Modal'

export const pluralize = (count, noun) => `${count || 0} ${noun}${count === 1 ? '' : 's'}`

export default observer(function ArchiveModal({ isOpen, onClose, title = 'Archive campaign', name, description, onConfirm, verb = 'archive', confirmLabel = 'Archive', pendingLabel = 'Archiving...' }) {
  const [isArchiving, setIsArchiving] = useState(false)

  const handleConfirm = () => {
    setIsArchiving(true)
    Promise.resolve(onConfirm())
      .then(() => onClose())
      .finally(() => setIsArchiving(false))
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <div className="w-[400px]">
          <p className="mb-3 font-bold dark:text-white">
            Are you sure you want to {verb} &quot;{name}&quot;?
          </p>
          <p className="text-sm text-rb-lighter-grey dark:text-gray-400">
            {description || 'It will be hidden from the campaigns view and become read only. You can restore it any time from the Archive.'}
          </p>

          <div className="flex justify-between mt-5">
            <button
              type="button"
              className="rb-btn-cancel font-bold text-md p-2 px-4 rounded-lg"
              onClick={onClose}
              disabled={isArchiving}
            >
              Cancel
            </button>
            <button
              type="button"
              className="ml-auto bg-rb-green text-white dark:text-rb-dark-mode rounded-lg p-2 px-4 submit text-center disabled:opacity-60"
              onClick={handleConfirm}
              disabled={isArchiving}
            >
              {isArchiving ? pendingLabel : confirmLabel}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
})
